import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import { immer } from 'zustand/middleware/immer';
import { abortController } from 'store/utils';
const initialState = {
    pitch: 45,
    zoom: undefined,
    center: undefined,
    zoomDirection: undefined,
    districtsVisibility: true,
    projectsVisibility: true,
    emiratesVisibility: true,
    metroVisibility: true,
    placesVisibility: true,
    isReady: false,
};
const actions = {
    setMapState: (payload, { setState }) => {
        if (typeof payload === 'function')
            setState((state) => ({ ...state, ...payload(state) }));
        else
            setState((state) => ({ ...state, ...payload }));
    },
};
const store = { ...initialState, ...actions };
export default create()(devtools(immer((set, get) => abortController(store, set, get, 'Map')), {
    name: 'Map',
}));
